import { Link, NavLink } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../Redux/hooks';
import { setLanguage, setTheme } from '../../../Redux/uiSlice';
import { useTranslation } from '../../../i18n/useTranslation';
import { routes } from '../../../Utils/routes';
import './Header.css';

// Line-art only: this app does not use emoji for controls. A circle with
// eight rays and a crescent, the two glyphs every icon set draws for
// light/dark.
const SUN_ICON = 'M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0zM12 1v2M12 21v2M4.22 4.22l1.42 1.42'
  + 'M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42';
const MOON_ICON = 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z';

export function Header() {
  const { tr, language } = useTranslation();
  const theme = useAppSelector(state => state.ui.theme);
  const dispatch = useAppDispatch();

  return (
    <header className="site-header">
      <Link className="brand" to={routes.home}>{tr('appName')}</Link>
      <nav className="site-nav">
        <NavLink to={routes.pricing}>{tr('navPricing')}</NavLink>
        <NavLink to={routes.app}>{tr('navApp')}</NavLink>
      </nav>
      <div className="site-header-controls">
        <button
          type="button"
          className="ghost-button"
          onClick={() => dispatch(setLanguage(language === 'he' ? 'en' : 'he'))}
          // The label names the language being switched to, written in that
          // language, so it reads correctly whichever one is currently on.
          aria-label={language === 'he' ? 'English' : 'עברית'}
        >
          {language === 'he' ? 'EN' : 'עב'}
        </button>
        <button
          type="button"
          className="ghost-button theme-toggle"
          onClick={() => dispatch(setTheme(theme === 'dark' ? 'light' : 'dark'))}
          aria-pressed={theme === 'dark'}
          aria-label={theme === 'dark' ? 'Light' : 'Dark'}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d={theme === 'dark' ? SUN_ICON : MOON_ICON} />
          </svg>
        </button>
      </div>
    </header>
  );
}
